
// モジュールを読込.
import { Options, Prop, Vue, Watch, Ref } from "vue-property-decorator"
import axios from "axios"
import Util from "packs/utils/Util"
import CalendarUtil from "packs/utils/CalendarUtil"
import isMobile from "ismobilejs"
import { DateTime } from "luxon"
import { Logger, copyToClipboard, funcName } from "packs/common"
import { gtagClick, gtagHover } from "packs/GoogleTagManager"
import SelectUtil from "packs/utils/SelectUtil"

// コンポーネントを読込.
import Switcher from "packs/components/forms/Switcher.vue"
import TextareaTag from "packs/components/forms/TextareaTag.vue"
import TextfieldTag from "packs/components/forms/TextfieldTag.vue"
import SelectTag from "packs/components/forms/SelectTag.vue"
import IconLock from "packs/components/icons/IconLock.vue"
import AutoCreateRoomRuleList from "packs/pages/link/parts/room_settings/left_panel_parts/AutoCreateRoomRuleList.vue"
import AutoCreateRoomRuleEditDetailContent from "packs/pages/link/parts/room_settings/left_panel_parts/AutoCreateRoomRuleEditDetailContent.vue"

// モデルを読込.
import RoomManager from "packs/models/RoomManager"
import Notice from "packs/models/Notice"
import Room from "packs/models/Room"
import RoomSetting from "packs/models/RoomSetting"
import UserSetting from "packs/models/UserSetting"
import TemplateUtil from "packs/utils/TemplateUtil"
import RoomCreateManager from "packs/models/RoomCreateManager"
import AppealContent from "packs/models/AppealContent"
import UserPermissionsOption from "packs/models/UserPermissionsOption"
import FormCreateManager from "packs/models/FormCreateManager"
import AutoCreateRoomRule from "packs/models/AutoCreateRoomRule"

@Options({
    components: {
        Switcher,
        TextareaTag,
        TextfieldTag,
        SelectTag,
        IconLock,
        AutoCreateRoomRuleList,
        AutoCreateRoomRuleEditDetailContent,
    },
})
export default class LeftNavPanelChukaiMenu extends Vue {
    // data:

    // image: ヘッダー画像, headerContent: ヘッダーテキスト, attendees: 出席者, locations: appoの場所選択, astag: 調整カレンダー選択
    // appo: タイトル/時間, message: オーナーからのメッセージ, pptos: pp/tosの変更
    @Prop()
    panelType: string

    @Prop()
    isPreview: boolean

    @Prop()
    isSuspend: boolean

    // @Prop() // func
    // inputMemo

    @Prop() // func
    linkCal

    @Ref()
    MailEditContent

    @Ref()
    AppointmentInfo

    @Ref()
    FormFieldEditContent

    rm = RoomManager
    rcm = RoomCreateManager
    fcm = FormCreateManager

    groupTitle = ""
    isSP = isMobile(window.navigator).phone

    doesChangeAppo: boolean
    notice = Notice
    Util = Util
    UserPermissionsOption = UserPermissionsOption
    CalendarUtil = CalendarUtil
    saving = false
    // showShareButton: boolean;
    // astag: AvailableScheduleTag = null

    contentWidth = 350

    loading = false
    isDrag = false

    imageUrl: string = null
    beforeUrl: string = null
    currentImageUrl: string = null

    imageTab = `custom`
    calendarTab = `list` // list / settings

    editOrNewForm = ``

    locationNames: string[] = null
    titles: string[] = null

    systemUpdatedAt = Util.getSec()
    acRules: AutoCreateRoomRule[] = []

    chukaiEmails: string = ``

    mounted() {
        this.getAutoCreateRoomRules()
        this.chukaiEmails = this.rcm.room_setting.chukai_send_mail_summary_to_emails
    }

    getAutoCreateRoomRules() {
        if (!this.rcm.room) return
        if (!this.rcm.room.id) return
        if (this.rcm.room.id == `newId`) return

        axios.get(`${Util.prefixUrl}/public_rooms/${this.rcm.room.id}/auto_create_room_rules`).then(res => {
            this.acRules = res.data.auto_create_room_rules as AutoCreateRoomRule[]
            this.rcm.ac_rules = this.acRules
            this.rcm.room_setting.auto_create_room_rules = this.acRules
            this.rcm.room_setting.fetched_ac_rules = true
        })
    }

    changeChukaiIsCreatePubRoomIfVoted(e) {
        Logger(`${funcName()}: ${e}`)
        if (this.rcm.room_setting.chukai_is_create_pub_room_if_voted) {
            this.rcm.room_setting.chukai_is_create_pub_room_if_voted = false
        } else {
            this.rcm.room_setting.chukai_is_create_pub_room_if_voted = true
        }
        this.rcm.updateRoomSetting(this.rcm.room_setting)
    }

    changeChukaiIsAvailableOpenSchedule(e) {
        Logger(`${funcName()}: ${e}`)
        if (this.rcm.room_setting.chukai_is_available_open_schedule) {
            this.rcm.room_setting.chukai_is_available_open_schedule = false
        } else {
            this.rcm.room_setting.chukai_is_available_open_schedule = true
        }
        this.rcm.updateRoomSetting(this.rcm.room_setting)
    }

    inputChukaiSendMailSummaryToEmails(e) {
        Logger(`${funcName()}: ${e}`)
        this.chukaiEmails = e
        this.rcm.room_setting.chukai_send_mail_summary_to_emails = e.split(",")
        this.rcm.updateRoomSetting(this.rcm.room_setting)
    }

    updateChukaiSendMailSummaryToEmails() {
        Logger(`${funcName()}: ${this.chukaiEmails}`)
        this.rcm.room_setting.chukai_send_mail_summary_to_emails = this.chukaiEmails
        this.rcm.updateRoomSetting(this.rcm.room_setting)
    }

    updateRoomSetting(setting: RoomSetting) {
        this.rcm.updateRoomSetting(setting)
    }

    updateRoom(room: Room) {
        this.rcm.updateRoom(room)
    }

    editContent(rule) {
        Logger(`${funcName()} rule:${Util.output(rule)}`)
        this.rcm.selectedRule = rule
    }

    removeRule(rule) {
        Logger(`${funcName()} rule:${Util.output(rule)}`)
        this.rcm.ac_rules = this.rcm.ac_rules.filter(r => r.id != rule.id)
        this.rcm.room_setting.auto_create_room_rules = this.rcm.ac_rules
        this.rcm.updateRoomSetting(this.rcm.room_setting)
    }

    addRule() {
        Logger(`${funcName()}`)
        if (!this.rm.canUseOption(`room_chukai_menu`, false)) {
            this.notice.message = `この機能はオプションのため、できません。`
            return
        }
        let rule = AutoCreateRoomRule.createDefault()
        this.rcm.selectedRule = rule
    }
}
